var numeral = require("numeral");
import "numeral/locales/es-es";
import "numeral/locales/pt-pt";
import "numeral/locales/it";
import "numeral/locales/en-gb";
export default {
    getReadTransform(value, transform) {
        if (value && !Number.isNaN(value) && value !== "" && transform) {
            return eval(transform.replace("this", value));
        }
    },
    getFormatAndSuffix(currency, area, frequency, precedent, value, format, localeFormat) {
        let replacedValue;
        const metricRegex = /c|a|f|p/gi;
        const numeralRegex = /%?\d+(?:[.,]\d*)*%?/gi;
        const replaceWith = {
            c: currency,
            a: area,
            f: frequency,
            p: precedent,
        };

        replacedValue = format.replace(numeralRegex, (match) => {
            numeral.locale(localeFormat)
            return numeral(Number(value)).format(match);
        });

        if (
            replacedValue !== null &&
            replacedValue !== undefined &&
            replacedValue !== ""
        ) {
            replacedValue = replacedValue.replace(metricRegex, (match) => {
                return replaceWith[match];
            });
        }

        return replacedValue;
    },
};
